import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=63057e62&scoped=true"
import script from "./latest.vue?vue&type=script&lang=ts"
export * from "./latest.vue?vue&type=script&lang=ts"
import style0 from "./latest.vue?vue&type=style&index=0&id=63057e62&prod&lang=scss"
import style1 from "./latest.vue?vue&type=style&index=1&id=63057e62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63057e62",
  null
  
)

export default component.exports